// extracted by mini-css-extract-plugin
export var alreadyRegistered = "components-data-__CmsHtmlStyle-module___alreadyRegistered";
export var cmsHtmlStyle = "components-data-__CmsHtmlStyle-module___cmsHtmlStyle";